import { render } from "./ManageOrder.vue?vue&type=template&id=b6e243e0&scoped=true"
import script from "./ManageOrder.vue?vue&type=script&lang=js"
export * from "./ManageOrder.vue?vue&type=script&lang=js"

import "./ManageOrder.vue?vue&type=style&index=0&id=b6e243e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6e243e0"]])

export default __exports__